/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { GlobalToast } from '@ba/ba-ui-carbon-toolkit';
import PropTypes from 'util/PropTypes';
import Config from './Config';

/**
 * This react component currently renders an action status bar as a toast message of different level.
 * such as error, warning, info, success.It's used for relationship diagram but it can
 * be used for any other use cases. As a special case, the toast message is rendered as an inline
 * toast message. It could be also extended to render other status information such as info icon.
 */
@observer
class RelationshipStatusBar extends Component {
	render(){
		const targetModel = this.props.targetModel;
		if(!targetModel){
			return null;
		}

		if(!targetModel.relationshipVM.isNewStartingPointsFeatureEnabled()){
			return null;
		}

		const actionStatus = targetModel.actionStatus;
		if(!actionStatus){
			return null;
		}

		const properties = {
			targetId: this.props.containerId,
			statusType: actionStatus.level,
			milliseconds: Config.diagram_status_bar_toast_time_duration,
			timedDismiss: actionStatus.level !== 'error', //For Error level status, toast meessage does not dismiss automatically
			contentString: `${actionStatus.message}`,
			style: {//GlobalToast supports style overriding using style property
				position: 'absolute',
				left: 0,
				top: '0px'
			},
			onClose: ()=> {
				targetModel.emptyActionStatus();
			}
		};
		return <GlobalToast {...properties}></GlobalToast>;
	}
}

RelationshipStatusBar.propTypes = {
	containerId:PropTypes.string.isRequired,
	targetModel: PropTypes.object
};

export default RelationshipStatusBar;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipStatusBar.js